import React from 'react';

/**
 * Dynamic Content
 * A passthrough for now.  Will be changed into an editable component.
 */
export default class DynamicContent extends React.Component {
    render() {
        return (
            <div {...this.props} className="component-dynamic-content">
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./web-app/components/dynamic-content.jsx